(() => {
  'use strict';

  const DD_AUTH_COPY={"tr":{"apple":"Apple ile giriş için ayrı Apple OAuth bağlantısı gerekli","form":"Hesap giriş formu"},"en":{"apple":"A separate Apple OAuth connection is required to sign in with Apple","form":"Account sign-in form"},"es":{"apple":"Se necesita una conexión OAuth de Apple independiente para iniciar sesión con Apple","form":"Formulario de inicio de sesión"},"ru":{"apple":"Для входа через Apple требуется отдельное подключение Apple OAuth","form":"Форма входа в аккаунт"},"ar":{"apple":"يلزم اتصال Apple OAuth منفصل لتسجيل الدخول باستخدام Apple","form":"نموذج تسجيل الدخول إلى الحساب"},"de":{"apple":"Für die Anmeldung mit Apple ist eine separate Apple-OAuth-Verbindung erforderlich","form":"Anmeldeformular"},"fr":{"apple":"Une connexion OAuth Apple distincte est requise pour se connecter avec Apple","form":"Formulaire de connexion"}};
  const ddAuthCopy=()=>DD_AUTH_COPY[String(document.documentElement.lang||"tr").toLowerCase().split("-")[0]]||DD_AUTH_COPY.tr;

  const VERSION = '2026-09-11-auth-modal-stable-v25';
  const ACCOUNT_SELECTOR = '[data-faire-dropdown="account"],.faire-site-header__dropdown--account';
  const GENERIC_ACCOUNT_RE = /(^|\/)(account)(\/)?(\?|#|$)|shopify\.com\/\d+\/account/i;

  window.__ddAuthModalV23 = VERSION;
  window.__ddAuthModalV24 = VERSION;

  const normalize = value => String(value || '').replace(/\s+/g,' ').trim().toLocaleLowerCase('tr-TR');

  function providerKey(node) {
    const text = normalize(node.textContent);
    const data = normalize(node.getAttribute('data-provider') || node.getAttribute('data-faire-provider') || node.getAttribute('aria-label') || '');
    const all = `${data} ${text}`;
    if (/apple|icloud/.test(all)) return 'apple';
    if (/google/.test(all)) return 'google';
    if (/meta|facebook/.test(all)) return 'meta';
    return '';
  }

  function cleanupBrokenV23(dropdown) {
    dropdown.querySelectorAll('.dd-auth-v23__visual,.dd-auth-v23__fallback-providers,.dd-auth-v23__social-note,.dd-auth-v23__divider').forEach(node => node.remove());
    dropdown.classList.remove('dd-auth-v23');

    const surface = dropdown.querySelector('.faire-site-header__dropdown-surface') || dropdown;
    surface.classList.remove('dd-auth-v23__surface');
    surface.classList.add('dd-auth-v24__surface');
    return surface;
  }

  function isLoginState(dropdown) {
    if (dropdown.querySelector('input[type="email"],input[type="password"]')) return true;
    const text = normalize(dropdown.textContent);
    return /hesabına gir|hesabina gir|giriş yap|giris yap|üye ol|uye ol|sign in|log in|register|iniciar sesión|registrarse|войти|регистрац|تسجيل الدخول|إنشاء حساب|anmelden|registrieren|se connecter|s[’']inscrire/.test(text);
  }

  function prepareProviders(dropdown) {
    const list = dropdown.querySelector('.faire-site-header__provider-list');
    if (!list) return;

    const controls = Array.from(list.querySelectorAll('a,button'));
    if (!controls.length) return;

    const disabledProviderRe = /draganddrop\.online\/login\?provider=/i;
    const activeControls = controls.filter(node => {
      const href = node.tagName === 'A' ? String(node.getAttribute('href') || '') : '';
      if (!disabledProviderRe.test(href)) return true;
      node.hidden = true;
      node.setAttribute('aria-hidden','true');
      node.setAttribute('tabindex','-1');
      return false;
    });

    const divider = list.previousElementSibling;
    if (!activeControls.length) {
      list.hidden = true;
      list.setAttribute('aria-hidden','true');
      if (divider && divider.classList.contains('faire-site-header__divider')) {
        divider.hidden = true;
        divider.setAttribute('aria-hidden','true');
      }
      return;
    }

    list.hidden = false;
    list.removeAttribute('hidden');
    list.setAttribute('aria-hidden','false');

    if (divider && divider.classList.contains('faire-site-header__divider')) {
      divider.hidden = false;
      divider.removeAttribute('hidden');
      divider.setAttribute('aria-hidden','false');
    }

    activeControls.forEach(node => {
      const key = providerKey(node);
      if (!key) return;
      node.classList.add(`dd-auth-v24__provider--${key}`);

      /* Never fake Apple OAuth. A custom, non-generic provider URL is respected. */
      if (key === 'apple') {
        const href = node.tagName === 'A' ? String(node.getAttribute('href') || '').trim() : '';
        if (!href || href === '#' || GENERIC_ACCOUNT_RE.test(href)) {
          node.classList.add('is-pending');
          node.setAttribute('aria-disabled','true');
          node.setAttribute('title',ddAuthCopy().apple);
          if (node.dataset.ddAppleGuard !== '1') {
            node.dataset.ddAppleGuard = '1';
            node.addEventListener('click', event => {
              event.preventDefault();
              event.stopPropagation();
            });
          }
        }
      }
    });
  }

  /* DD_QA_FORM_SEMANTICS_20260911 */
  function ensureAuthForm(dropdown) {
    const fieldList = dropdown.querySelector('.faire-site-header__field-list');
    if (!fieldList || fieldList.closest('form')) return;

    const form = document.createElement('form');
    form.className = 'dd-auth-v24__form';
    form.setAttribute('aria-label', ddAuthCopy().form);
    form.setAttribute('novalidate', '');
    form.addEventListener('submit', event => {
      event.preventDefault();
      const submit = fieldList.querySelector('[data-faire-auth-submit]');
      if (submit && !submit.disabled) submit.click();
    });

    fieldList.parentNode.insertBefore(form, fieldList);
    form.appendChild(fieldList);
  }

  function enhance(dropdown) {
    if (!(dropdown instanceof HTMLElement)) return;

    cleanupBrokenV23(dropdown);
    dropdown.classList.add('dd-auth-v24');

    const login = isLoginState(dropdown);
    dropdown.classList.toggle('dd-auth-v24--login', login);

    if (login) {
      ensureAuthForm(dropdown);
      prepareProviders(dropdown);
    }
  }

  let raf = 0;
  function scan() {
    raf = 0;
    document.querySelectorAll(ACCOUNT_SELECTOR).forEach(enhance);
  }

  function queue() {
    if (raf) return;
    raf = requestAnimationFrame(scan);
  }

  document.addEventListener('click', event => {
    if (!(event.target instanceof Element)) return;
    if (event.target.closest('[data-faire-toggle-dropdown="account"],[data-faire-dock-account],[data-faire-fallback-account]')) {
      setTimeout(scan,0);
      setTimeout(scan,100);
      setTimeout(scan,260);
    }
  },true);

  const observer = new MutationObserver(queue);
  observer.observe(document.documentElement,{
    childList:true,
    subtree:true,
    attributes:true,
    attributeFilter:['class','hidden','aria-hidden']
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded',scan,{once:true});
  } else {
    scan();
  }

  document.addEventListener('shopify:section:load',queue);
})();
